import React from "react";
import "../assets/css/LsFormModern.css";

export function hasFooterHtml(html?: string | null): boolean {
  if (!html) return false;
  return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim().length > 0;
}

type DirectoryFooterTextProps = {
  html?: string | null;
  emptyLabel?: string;
  onEdit?: () => void;
};

export default function DirectoryFooterText({
  html,
  emptyLabel,
  onEdit,
}: DirectoryFooterTextProps) {
  const hasContent = hasFooterHtml(html);

  if (!hasContent && !emptyLabel && !onEdit) {
    return null;
  }

  return (
    <div
      className={`dir-footer-text-wrap${onEdit ? " dir-footer-text-wrap--editable" : ""}`}
    >
      {onEdit ? (
        <button
          type="button"
          className="dir-footer-edit-btn"
          onClick={onEdit}
        >
          <i className="mdi mdi-pencil" aria-hidden="true" />
          Edit footer text
        </button>
      ) : null}
      {hasContent ? (
        <div
          className="dir-footer-text"
          dangerouslySetInnerHTML={{ __html: html as string }}
        />
      ) : emptyLabel ? (
        <div className="dir-footer-text dir-footer-text--empty">{emptyLabel}</div>
      ) : null}
    </div>
  );
}
